import React, { Component } from "react";
import { Button, ButtonToolbar } from "react-bootstrap";
import { PageHeader, ListGroup, ListGroupItem } from "react-bootstrap";
import { API } from "aws-amplify";
import AllHabits from "../containers/AllHabits";
import FeatureOverview from "../containers/FeatureOverview";

import "./Home.css";
import demo from '../images/Demo.gif';
import logo from '../logo.svg';
import logoHover from '../logoHover.svg';

export default class Home extends Component {
  constructor(props) {
    super();

    this.loadHabits = this.loadHabits.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleLeft = this.handleLeft.bind(this);
    this.handleRight = this.handleRight.bind(this);
    this.handleTodayRight = this.handleTodayRight.bind(this);
    this.handleMouse = this.handleMouse.bind(this);
    this.handleHoverMove = this.handleHoverMove.bind(this);
    this.handleLogoHover = this.handleLogoHover.bind(this);

    var numDays = this.calculateNumDays();
    var startDate = new Date();
    startDate.setDate(startDate.getDate() - numDays);

    this.fullDaysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    this.state = {
      isLoading: true,
      habits: [],
      user: null,
      isEditMode: true,
      mouseIsDown: false,
      numDays: numDays,
      startDate: startDate,
      isLogoHovered: false
    };
  }

  calculateNumDays() {
    return Math.floor((window.innerWidth) / 70 - 4);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  componentWillMount() {
     this.handleResize();
  }

  handleResize(WindowSize, event) {
      var numDays = this.calculateNumDays();
      this.setState({ numDays: numDays })
  }

  async componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    if (!this.props.isAuthenticated) {
      return;
    }

    try {
      await this.loadHabits();
    } catch (e) {
      alert(e);
    }

    this.setState({ isLoading: false });
  }

  async loadHabits() {
    var user;
    try {
      user = await this.user();
    } catch (e) {
    }

    const habits = await this.habits();
    if (user != null) {
      habits.sort(function(a, b){
        return user.habitOrder.indexOf(a.habitId) - user.habitOrder.indexOf(b.habitId);
      });
    }

    this.setState({
       habits: habits,
       user: user
     });
  }

  async updateHabitOrder(habitOrder) {
    return API.put("users", "/users", {
      body: {
        habitOrder: habitOrder
      }
    });
  }

  async habits() {
    return API.get("habits", "/habits");
  }

  async user() {
    return API.get("users", "/users");
  }

  handleEditClick() {
    // this.setState({
    //   isEditMode: !this.state.isEditMode
    // })
  }

  async handleLeft() {
    var x = this.state.startDate;
    x.setDate(x.getDate() - 1);
    this.setState({
      startDate: x
    });
    await this.loadHabits();
  }

  async handleRight() {
    var x = this.state.startDate;
    x.setDate(x.getDate() + 1);
    this.setState({
      startDate: x
    });
    await this.loadHabits();
  }

  async handleTodayRight() {
    var startDate = new Date();
    startDate.setDate(startDate.getDate() - this.state.numDays);
    this.setState({
      startDate: startDate
    });
    await this.loadHabits();
  }

  handleHoverMove(to, from) {
    if (to == from) {
      return;
    }
    var toIndex = this.state.user.habitOrder.indexOf(to);
    var fromIndex = this.state.user.habitOrder.indexOf(from);

    var user = JSON.parse(JSON.stringify(this.state.user));
    this.arrayMove(user.habitOrder, fromIndex, toIndex);

    var habits = JSON.parse(JSON.stringify(this.state.habits));
    habits.sort(function(a, b) {
      return user.habitOrder.indexOf(a.habitId) - user.habitOrder.indexOf(b.habitId);
    });
    this.setState({
      user: user,
      habits: habits
    });
    return user.habitOrder;
  }

  arrayMove(arr, fromIndex, toIndex) {
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
  }

  isTodayRight() {
    var startDate = new Date();
    startDate.setDate(startDate.getDate() - this.state.numDays);
    if (this.isSameDate(startDate, this.state.startDate)) {
      return true;
    }
    return false;
  }

  isSameDate(x , y) {
    if (x.getFullYear() === y.getFullYear() &&
        x.getMonth() === y.getMonth() &&
        x.getDate() === y.getDate()) {
          return true;
    }
    return false;
  }

  logo() {
    var width = (window.innerWidth);
    if (width < 1280) {
      return <img src={demo} style={{width:width, marginTop: -8, marginRight: 12}} />
    } else {
      return <img src={demo} style={{width:1280, marginTop: -8, marginRight: 12}} />
    }
  }

  handleLogoHover() {
    this.setState({
      isLogoHovered: !this.state.isLogoHovered
    });
  }

  renderLander() {
    var demoStyle = {
      width: '50%',
      marginLeft: '10%',
      marginRight: '15%'
    }
    return (
      <div>
        <div className="lander" onMouseEnter={ this.handleLogoHover} onMouseLeave={ this.handleLogoHover }>
        <h2>the power of habit</h2>
        { this.logo() }
          <h3>a minimalistic, beautiful, habit tracking app</h3>

          <div className="loginButtons">
          <Button
            onMouseEnter={ this.handleLogoHover}
            onMouseLeave={ this.handleLogoHover }
            bsSize="large" href="/login"
            className="bigButton" block>GET STARTED
          </Button>
          </div>
        </div>
        <FeatureOverview>
        </FeatureOverview>
      </div>
    );
  }

//          <img src={demo} style={ demoStyle } />

  markingAvailableToday() {
    var noHabitsToMark = false;
    var today = this.fullDaysOfWeek[new Date().getDay()];
    for (var i = 0; i < this.state.habits.length; i++) {
      var habit = this.state.habits[i];
      var days = habit.days.values;
      for (var j = 0; j < days.length; j++) {
        if (days[j] == today) {
          return true;
        }
      }
    }
    return false;
  }

  markingAvailableToday() {
    var noHabitsToMark = false;
    var dayToday = this.fullDaysOfWeek[new Date().getDay()];
    for (var i = 0; i < this.state.habits.length; i++) {
      var habit = this.state.habits[i];
      var days = habit.days.values;
      for (var j = 0; j < days.length; j++) {
        if (days[j] == dayToday) {
          return true;
        }
      }
    }
    return false;
  }

  allHabitsMarkedToday() {
    if (!this.markingAvailableToday) {
      return false;
    }
    var allHabitsMarkedToday = true;
    var dayToday = this.fullDaysOfWeek[new Date().getDay()];
    for (var i = 0; i < this.state.habits.length; i++) {
      var habit = this.state.habits[i];
      var days = habit.days.values;
      for (var j = 0; j < days.length; j++) {
        if (days[j] == dayToday) {
          var today = this.getTodayDateString(new Date());
          if (habit.marks == null) {
            return false;
          }
          if (habit.marks && habit.marks.values.indexOf(today) == -1) {
            return false;
          }
        }
      }
    }
    return true;
  }

  numHabitsNotMarked() {
    var num = 0;
    var dayToday = this.fullDaysOfWeek[new Date().getDay()];
    for (var i = 0; i < this.state.habits.length; i++) {
      var habit = this.state.habits[i];
      var days = habit.days.values;
      for (var j = 0; j < days.length; j++) {
        if (days[j] == dayToday) {
          var today = this.getTodayDateString(new Date());
          if (habit.marks == null) {
            num += 1;
          }
          if (habit.marks && habit.marks.values.indexOf(today) == -1) {
            num += 1;
          }
        }
      }
    }
    return num;
  }

  getTodayDateString(dateObj) {
    var year = dateObj.getFullYear();
    var date = dateObj.getDate();
    var month = (dateObj.getMonth() + 1).pad(2);
    return Number(year.toString() + month + date.toString());
  }

  renderHabits() {
    if (this.state.isLoading) {
      return (
        <div className="spinner">
          <div className="bounce1"></div>
          <div className="bounce2"></div>
          <div className="bounce3"></div>
        </div>
      )
    }
    var editButton = null;
    var divStyle = {
      backgroundColor: 'rgb(224,228,204)',
      color: 'rgb(74,74,74)'
    };
    if (this.state.isEditMode) {
      // editButton = <div
      //                onClick = { this.handleEditClick }
      //                className = "editButton"
      //                style={ divStyle }
      //              >
      //                { "Editing history... click to SAVE" }
      //              </div>;
    }

    var statusButton = null;
    if (!this.markingAvailableToday()) {
      var divStyle = {
        backgroundColor: "rgb(132,176,62,.8)",
        color: 'white'
      };
      statusButton = <div
                className = "statusButton"
                style={ divStyle }
              >
                { "No habits to mark today!" }
              </div>;
    }
    else if (this.allHabitsMarkedToday()) {
      var divStyle = {
        backgroundColor: "rgb(138,155,15,.8)",
        color: 'white'
      };
      statusButton = <div
                className = "statusButton"
                style={ divStyle }
              >
                { "All habits marked for today!" }
              </div>;
    } else {
      var divStyle = {
        backgroundColor: "#4A4A4A",
        color: 'white'
      };
      // statusButton = <div
      //           className = "statusButton"
      //           style={ divStyle }
      //         >
      //           { this.numHabitsNotMarked() > 1 ?
      //              this.numHabitsNotMarked() + " habits left today!"
      //             :
      //             this.numHabitsNotMarked() + " habit left today!"
      //          }
      //         </div>;
    }
    var todayButton = null;

    if (!this.isTodayRight()) {
      todayButton = <div
                className="todayButton"
                style={ divStyle }
                onClick = { this.handleTodayRight }
              >
                { "Go to today" }
              </div>;
    }
    if (this.state.habits.length === 0) {
      return (
        <div className="lander">
          <div className="actionButtons">
          <Button bsSize="large" className="bigButton" type="button" href="/habits/new">Create a habit</Button>
          </div>
        </div>
      );
    }
    return (
      <div
      >
        <div className="attention">
          {/* { statusButton } */}
        </div>
        <div
          className="habits"
          onMouseUp={ this.handleMouse }
          onMouseDown={ this.handleMouse }
        >
            <AllHabits
              habits={this.state.habits}
              user={this.state.user}
              loadHabits={this.loadHabits}
              colorScheme={this.props.colorScheme}
              isEditMode={this.state.isEditMode}
              startDate={this.state.startDate}
              numDays={this.state.numDays}
              handleLeft={this.handleLeft}
              handleRight={this.handleRight}
              handleTodayRight={this.handleTodayRight}
              handleEditClick={this.handleEditClick}
              mouseIsDown={this.state.mouseIsDown}
              handleMouse={this.handleMouse}
              handleHoverMove={this.handleHoverMove}
              updateHabitOrder={this.updateHabitOrder}
            >
            </AllHabits>
        </div>
      </div>
    );
  }

  handleMouse() {
    this.setState({
      mouseIsDown: !this.state.mouseIsDown
    });
  }

  isMobile() {
    var width = (window.innerWidth);
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || width < 500) {
      return true;
    }
    return false;
  }

  render() {
    return (
      <div className="Home">
        {this.props.isAuthenticated ? this.renderHabits() : this.renderLander()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Home.js